import React, { useState } from 'react';
import { api } from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card } from '@/components/ui/card';
import { IndivalifeLogo } from '@/components/IndivalifeLogo';
import { Shield } from 'lucide-react';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';

const AdminLogin = () => {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('admin@indivalife.com');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post('/admin/login', { email, password });
      setUser(data.user);
      navigate(data.admin_link || '/admin');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Invalid credentials');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[var(--bz-soft)]">
      <Card className="p-8 max-w-md w-full mx-4">
        <div className="flex items-center justify-center mb-4"><IndivalifeLogo size={56} /></div>
        <div className="text-center mb-6">
          <div className="text-xs uppercase tracking-[0.3em] text-[var(--bz-muted)] font-semibold">INDIVALIFE</div>
          <h1 className="text-2xl font-black tracking-tighter display flex items-center justify-center gap-2 mt-1"><Shield className="h-5 w-5 text-[#1E3A8A]" />Admin Control Room</h1>
        </div>
        <div className="space-y-3">
          <div><Label>Admin email</Label><Input value={email} onChange={e => setEmail(e.target.value)} data-testid="admin-email-input" /></div>
          <div><Label>Password</Label><Input type="password" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === 'Enter' && submit()} data-testid="admin-password-input" /></div>
        </div>
        <Button onClick={submit} disabled={busy} className="w-full mt-4 bg-[#1D4ED8] hover:bg-[#1E3A8A]" data-testid="admin-login-button">{busy ? 'Logging in…' : 'Enter'}</Button>
      </Card>
    </div>
  );
};

export default AdminLogin;
